import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "bar", "count", "form", "idsField", "actionButton"]

  connect() {
    this.injectSelectAllCheckbox()
    this.updateBar()
  }

  injectSelectAllCheckbox() {
    const headerCell = this.element.querySelector("th.data-table-checkbox-col")
    if (!headerCell || headerCell.querySelector("input")) return

    const cb = document.createElement("input")
    cb.type = "checkbox"
    cb.className = "bulk-select-checkbox"
    cb.dataset.bulkSelectTarget = "selectAll"
    cb.dataset.action = "change->bulk-select#toggleAll"
    headerCell.textContent = ""
    headerCell.appendChild(cb)
  }

  toggle() {
    this.syncSelectAll()
    this.updateBar()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.selectableCheckboxes().forEach(cb => { cb.checked = checked })
    this.updateBar()
  }

  updateBar() {
    const selected = this.selectedIds()
    const count = selected.length
    const hasSelection = count > 0

    if (this.hasBarTarget) {
      if (hasSelection) {
        this.barTarget.hidden = false
        if (this.hasCountTarget) {
          this.countTarget.textContent = `${count} selected`
        }
      } else {
        this.barTarget.hidden = true
      }
    }

    if (this.hasIdsFieldTarget) {
      this.idsFieldTarget.value = selected.join(",")
    }

    if (this.hasActionButtonTarget) {
      this.actionButtonTargets.forEach((button) => {
        button.disabled = !hasSelection
      })
    }
  }

  selectedIds() {
    return this.selectableCheckboxes()
      .filter(cb => cb.checked)
      .map(cb => cb.value)
  }

  visibleCheckboxes() {
    return this.checkboxTargets.filter(cb => !cb.closest("tr[hidden]"))
  }

  selectableCheckboxes() {
    return this.visibleCheckboxes().filter(cb => !cb.disabled)
  }

  syncSelectAll() {
    const selectable = this.selectableCheckboxes()
    if (!this.hasSelectAllTarget || selectable.length === 0) return
    this.selectAllTarget.checked = selectable.every(cb => cb.checked)
  }

  clearSelection() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = false
    }

    this.updateBar()
  }
}
